import request from './request';

export const login = (data: { username: string, password: string }) =>
  request({
    url: '/carbon-auth/public/auth/user/login/usr/pwd',
    method: 'post',
    data
  });

export const logout = () =>
  request({
    url: '/carbon-auth/private/user/center/user/logout',
    method: 'get'
  });

export const getLoginBanner = ({language}: {language: string}) =>
  request({
    url: '/carbon-misc/public/web/config/login/banner',
    method: 'get',
    params: {
      language
    }
  }, {
    skipTime: 15000
  });
